const t = {
  name: "CrossCircle",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4144 12L16.4144 15L15.0002 16.4142L12.0002 13.4142L9.00015 16.4142L7.58594 15L10.5859 12L7.58594 9.00003L9.00015 7.58582L12.0002 10.5858L15.0002 7.58582L16.4144 9.00003L13.4144 12Z" fill="currentColor"/>
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as CrossCircle
};
